function formCheck(input) {
    const inputId = input.id;
    input.setAttribute("aria-invalid", !input.checkValidity());

    for (const notification of input.parentNode.querySelectorAll('.inputNotification')) {
        notification.remove();
    }

    if (!input.checkValidity()) {
        input.setAttribute('aria-describedby', inputId + '-error');
        input.classList.add("error");

        const slidecontentWrapper = input.closest('.slidecontent__container');

        if (slidecontentWrapper && !slidecontentWrapper.classList.contains("is-active")) {
            slidecontentWrapper.classList.add("is-active");
        }
        return false;
    } else {
        input.removeAttribute('aria-describedby');
        input.classList.remove("error");
        return true;
    }
}

export function validateForm(form) {
    let formIsValid = true;

    for (const input of form.querySelectorAll('input:not([type=hidden]),select,textarea')) {
        const inputIsValid = formCheck(input);

        if (!inputIsValid) {
            formIsValid = false;
        }

        input.addEventListener(
            "blur", event => {
                formCheck(input);
            },
            false
        );
    }

    return formIsValid;
}

export function trimInputValues(query = document.querySelectorAll('.js-trimInputValue')) {
    for (const input of query) {
        input.addEventListener("change", function () {
            input.value = input.value.trim();
        });
    }
}